$(document).ready(function () {

    $(".form-item-field-theme-description-0-value").hide();

    $("input[name='field_themes_af[Other]']").change(function () {
        if ($(this).prop("checked") == true) {
            $(".form-item-field-theme-description-0-value").show()
        } else {
            $(".form-item-field-theme-description-0-value").hide()
        }
    });

    $(".form-item-field-source-of-declared-action--0-value").hide();
    $("input[name='field_source_of_declared_action']").change(function () {
        if ($(this).val() == "Regional Urban Forum" || $(this).val() == "National Urban Forum" || $(this).val() == "Other") {
            $(".form-item-field-source-of-declared-action--0-value").show();
        } else {
            $(".form-item-field-source-of-declared-action--0-value").hide();
        }
    });

    if ($("input[name='field_source_of_declared_action']:checked").val() == "Regional Urban Forum"
        || $("input[name='field_source_of_declared_action']:checked").val() == "National Urban Forum"
        || $("input[name='field_source_of_declared_action']:checked").val() == "Other") {
        $(".form-item-field-source-of-declared-action--0-value").show();
    }

    $(".form-item-field-organization-type-details--0-value").hide();

    $('select[name="field_type_of_organization_af"]').change(function () {
        var $option = $(this).find('option:selected');
        var value = $option.text();

        if (value == "Others (specify)") {
            $(".form-item-field-organization-type-details--0-value").show();
        } else {
            $(".form-item-field-organization-type-details--0-value").hide();
        }
    });

    if ($('select[name="field_type_of_organization_af"]').find('option:selected').text() == "Others (specify)" || $('select[name="field_type_of_organization_af"]').find('option:selected').text() == "Others") {
        $(".form-item-field-organization-type-details--0-value").show();
    }

    // date filter validation
    $('select[name="field_start_year_af_value"]').change(function () {
        checkStartEndYear();
    });

    $('select[name="field_completion_year_af_value"]').change(function () {
       checkStartEndYear();
    });

    function checkStartEndYear() {
        var startElement = $('select[name = "field_start_year_af_value"]');
        var endElement = $('select[name="field_completion_year_af_value"]')
        var startYearValue = $(startElement).val();
        var endYearValue = $(endElement).val();
        var addPaddingTop = $('.action-filter-wrap1 .form-actions');
        $('.syear_error').remove();
        if (startYearValue != '' && endYearValue != '' && (startYearValue > endYearValue)) {
            $('<div class="error syear_error">Start year always be less or equal to end year</div>').insertAfter(startElement);
        } else {
            $('.syear_error').remove();
        }
        if (startYearValue != '' && endYearValue != '' && (startYearValue > endYearValue)) {
            $('<div class="error syear_error">End year always be greater or equal to start year</div>').insertAfter(endElement);
            addPaddingTop.css('padding-top', '30px')
        } else {
            $('.syear_error').remove();
            addPaddingTop.css('padding-top', '0px')
        }
    }
});